var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('img',{attrs:{"alt":"EMS logo","src":require("../assets/image/avatar.png")}}),_c('HelloWorld',{attrs:{"msg":_vm.msg}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }